import * as vcc from 'vanilla-cookieconsent';


/**
 * Loads the cookie consent banner
 */
function consentRunner()
{

    // obtain plugin
    var cc = initCookieConsent();

// run plugin with your configuration
    cc.run({
        current_lang: 'en',
        autoclear_cookies: true,                   // default: false
        page_scripts: true,                        // default: false
        mode: 'opt-out',                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'

        languages: {
            'en': {
                consent_modal: {
                    title: 'We use cookies!',
                    description: 'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it.  Please read the full <a href="/cookie-policy" target = "_blank" class="cc-link">cookie policy</a>.',
                    primary_btn: {
                        text: 'OK',
                        role: 'accept_all'              // 'accept_selected' or 'accept_all'
                    }
                },
                settings_modal: {
                    title: 'Cookie preferences',
                    save_settings_btn: 'Save settings',
                    accept_all_btn: 'Accept all',
                    reject_all_btn: 'Reject all',
                    close_btn_label: 'Close',
                    cookie_table_headers: [
                        {col1: 'Name'},
                        {col2: 'Domain'},
                        {col3: 'Expiration'},
                        {col4: 'Description'}
                    ],
                    blocks: [
                        {
                            title: 'Cookie usage 📢',
                            description: 'We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="/cookie-policy" target = "_blank" class="cc-link">cookie policy</a>.'
                        }, {
                            title: 'Strictly necessary cookies',
                            description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: 'XSRF-TOKEN',
                                    col2: '/',
                                    col3: '2 hours',
                                    col4: 'Used to protect the website',
                                    is_regex: true
                                },
                            ]
                        },
                        //Can show this for GA if we want
                        // {
                        //     title: 'Performance and Analytics cookies',
                        //     description: 'These cookies allow the website to remember the choices you have made in the past',
                        //     toggle: {
                        //         value: 'analytics',     // your cookie category
                        //         enabled: true,
                        //         readonly: false
                        //     },
                        //     cookie_table: [             // list of all expected cookies
                        //         {
                        //             col1: '^_ga',       // match all cookies starting with "_ga"
                        //             col2: 'google.com',
                        //             col3: '2 years',
                        //             col4: 'Used to track analytics across the site',
                        //             is_regex: true
                        //         }
                        //     ]
                        // },
                        //{
                        //     title: 'Advertisement and Targeting cookies',
                        //     description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
                        //     toggle: {
                        //         value: 'targeting',
                        //         enabled: false,
                        //         readonly: false
                        //     }
                        // },
                        // {
                        //     title: 'More information',
                        //     description: 'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="#yourcontactpage">contact us</a>.',
                        // }
                    ]
                }
            }
        },
    });
}

export default consentRunner;
